import React, { useEffect, useState, useMemo } from "react";
import "./AddEditCustomer.scss";
import LinedTitle from "../../LinedTitle/LinedTitle";
import DynaInput from "../../../A13/DynaView/DynaInput";
import DynaSelectBox from "../../../A13/DynaView/DynaSelectBox";
import _axios from "../../../../httpService";
import { prefixUrl } from "../../../../utils/utilsData";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../../Loader";
import UtilsFunctions from "../../../../utils/UtilsFunctions";
import provincesData from "../../../../Assets/data/provinces.json";
import citiesData from "../../../../Assets/data/cities.json";

const AddEditCustomer = () => {
  const navigateTo = useNavigate();
  const myLocation = useLocation();
  const customerId = myLocation?.state?.id;
  const isEditMode = myLocation?.state?.mode === "edit";
  /*** استیت ها ***/
  const [loading, setLoading] = useState(isEditMode);
  const [sendData, setSendData] = useState({
    name: "",
    mobile: "",
    code: "",
    province: "",
    city: "",
    address: "",
    profit_percent: "",
    purchase_collection: "",
  });

  const provinceOptions = useMemo(() => {
    return provincesData.map(p => ({ value: p.name, label: p.name, id: p.id }));
  }, []);

  const [selectedProvinceId, setSelectedProvinceId] = useState(null);

  const cityOptions = useMemo(() => {
    if (!selectedProvinceId) return [];
    return citiesData
      .filter(c => c.province_id === selectedProvinceId)
      .map(c => ({ value: c.name, label: c.name }));
  }, [selectedProvinceId]);

  const getEditModeData = async () => {
    try {
      setLoading(true);
      const response = await _axios.get(
        prefixUrl() + "/cheeka/moshtari/index.php?id=" + customerId
      );
      if (response?.data?.status) {
        const data = response.data.data;
        setSendData(data);
        
        // Find province id to load cities
        const province = provincesData.find(p => p.name === data.province);
        if (province) {
          setSelectedProvinceId(province.id);
        }
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("خطا در ارتباط با سرور");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isEditMode) {
      void getEditModeData();
    }
  }, [isEditMode]);

  const handleProvinceChange = (selected) => {
    setSendData({ ...sendData, province: selected.value, city: "" });
    setSelectedProvinceId(selected.id || null);
  };
  

  const handleCityChange = (selected) => {
    setSendData({ ...sendData, city: selected.value });
  };

  const handleSubmit = async () => {
    const dataToSend = {
      name: sendData?.name,
      mobile: sendData?.mobile,
      code: sendData?.code,
      province: sendData?.province,
      city: sendData?.city,
      address: sendData?.address,
      profit_percent: sendData?.profit_percent,
      purchase_collection: sendData?.purchase_collection,
    };

    if (isEditMode) {
      dataToSend.id = customerId;
    }

    try {
      const request = _axios.post(
        prefixUrl() + "/cheeka/moshtari/index.php",
        dataToSend
      );

      toast.promise(request, {
        pending: "در حال ثبت مشتری...",
      });

      const response = await request;

      if (response.data.status) {
        toast.success(response.data.message);
        navigateTo(-1);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("خطا در ارتباط با سرور");
    }
  };

  const validateForm = () => {
    if (!sendData.name || sendData.name.trim() === "") {
      toast.error("نام مشتری اجباری است");
      return false;
    }
    if (!sendData.mobile) {
      toast.error("شماره تماس اجباری است");
      return false;
    }
    if (!UtilsFunctions.validateMobile(sendData.mobile)) {
      toast.error("شماره تماس معتبر نیست");
      return false;
    }
    if (!sendData.code) {
      toast.error("کد راهکاران سیستم اجباری است");
      return false;
    }
    if (!sendData.province || sendData.province.trim() === "") {
      toast.error("استان اجباری است");
      return false;
    }
    if (!sendData.city || sendData.city.trim() === "") {
      toast.error("شهر اجباری است");
      return false;
    }
    return true;
  };

  try {
    return loading ? (
      <Loader />
    ) : (
      <section className="add__edit__customer">
        <div className="content__section">
          <LinedTitle title={"مشخصات مشتری"} />
          <div className="grid__section">
            <div style={{ gridColumn: "1/-1" }}>
              <DynaInput
                label={"نام مشتری *"}
                name={"name"}
                className={"solid-dyna-input"}
                placeholder={" نام مشتری را وارد کنید"}
                value={sendData?.name}
                type={"text"}
                setDataFromComponent={(data) =>
                  setSendData({ ...sendData, ...data })
                }
              />
            </div>
            <DynaInput
              label={"شماره تماس *"}
              name={"mobile"}
              className={"solid-dyna-input"}
              placeholder={"شماره تماس را وارد کنید"}
              value={sendData?.mobile}
              type={"number"}
              setDataFromComponent={(data) =>
                setSendData({ ...sendData, ...data })
              }
            />
            <DynaInput
              label={"کد راهکاران سیستم *"}
              name={"code"}
              className={"solid-dyna-input"}
              placeholder={" کد راهکاران سیستم را وارد کنید"}
              value={sendData?.code}
              type={"number"}
              setDataFromComponent={(data) =>
                setSendData({ ...sendData, ...data })
              }
            />
            <DynaSelectBox
              label={"استان *"}
              name={"province"}
              className={"solid-dyna-input"}
              options={provinceOptions}
              value={sendData?.province}
              hasFilter={true}
              onChange={handleProvinceChange}
            />
            <DynaSelectBox
              label={"شهر *"}
              name={"city"}
              className={"solid-dyna-input"}
              options={cityOptions}
              value={sendData?.city}
              hasFilter={true}
              onChange={handleCityChange}
              disabled={!selectedProvinceId}
            />
            <div style={{ gridColumn: "1/-1" }}>
              <DynaInput
                label={"آدرس"}
                name={"address"}
                className={"solid-dyna-input"}
                placeholder={" آدرس را وارد کنید"}
                value={sendData?.address}
                type={"text"}
                setDataFromComponent={(data) =>
                  setSendData({ ...sendData, ...data })
                }
              />
            </div>
            <DynaInput
              label={"درصد حاشیه سود"}
              name={"profit_percent"}
              className={"solid-dyna-input"}
              placeholder={" درصد حاشیه سود را وارد کنید"}
              value={UtilsFunctions.addCommas(sendData?.profit_percent)}
              type={"text"}
              hasComma={true}
              setDataFromComponent={(data) =>
                setSendData({ ...sendData, ...data })
              }
            />
            <DynaInput
              label={"جمع خرید"}
              name={"purchase_collection"}
              className={"solid-dyna-input"}
              placeholder={"جمع خرید را وارد کنید"}
              value={UtilsFunctions.addCommas(sendData?.purchase_collection)}
              type={"text"}
              hasComma={true}
              setDataFromComponent={(data) =>
                setSendData({ ...sendData, ...data })
              }
            />
          </div>
        </div>
        <div className="bottom__section">
          <div className="action__buttons">
            <button onClick={() => navigateTo(-1)} className="cancel__button">
              انصراف
            </button>
            <button
              onClick={() => {
                if (validateForm()) {
                  handleSubmit();
                }
              }}
              className="submit__button"
            >
              {isEditMode ? "ویرایش" : "ثبت"}
            </button>
          </div>
        </div>
      </section>
    );
  } catch (e) {
    return <>{e.toString()}</>;
  }
};

export default AddEditCustomer;
